// Who is signed in, for code that has no user passed to it (the chat anchor
// search, the command palette, meeting prep). The app shell sets it whenever the
// user record changes. Until the record has arrived nobody is known, and an
// unknown user is treated as NOT staff, the same rule the ticket list uses.

interface SessionUser {
	id?: number;
	level?: number;
}

let current: SessionUser | null = null;

export function setSessionUser(u: SessionUser | null | undefined): void {
	current = u ?? null;
}

/** Communico staff the app KNOWS are staff: level exactly 1 (the server's
 * definition, middleware.UserLevelCommunicoStaff; level 2 is not staff) and a user id. */
export function isKnownCommunicoStaff(): boolean {
	return (current?.id ?? 0) > 0 && current?.level === 1;
}
